module.exports = __webpack_public_path__ + "static/media/student-score-300p.3028aab2.png";